import {
  Rocket, BarChart3, Factory, Package, Zap, Truck, Leaf
} from 'lucide-react';
import { faqContent } from './faqContent';

export const faqCategories = [
  {
    id: 'getting-started',
    icon: Rocket,
    title_fr: 'Premiers pas',
    title_de: 'Erste Schritte',
    color: 'blue',
    questions: faqContent['getting-started']
  },
  {
    id: 'dashboard',
    icon: BarChart3,
    title_fr: 'Tableau de bord',
    title_de: 'Dashboard',
    color: 'purple',
    questions: faqContent['dashboard']
  },
  {
    id: 'scopes',
    icon: Factory,
    title_fr: 'Scopes & Cat\u00e9gories',
    title_de: 'Scopes & Kategorien',
    color: 'amber',
    questions: faqContent['scopes']
  },
  {
    id: 'products',
    icon: Package,
    title_fr: 'Produits vendus',
    title_de: 'Verkaufte Produkte',
    color: 'green',
    questions: faqContent['products']
  }
];

export const scopeConfig = {
  scope1: { color: 'blue', label_fr: 'Scope 1', label_de: 'Scope 1', icon: Factory },
  scope2: { color: 'cyan', label_fr: 'Scope 2', label_de: 'Scope 2', icon: Zap },
  scope3_amont: { color: 'amber', label_fr: 'Scope 3 Amont', label_de: 'Scope 3 Upstream', icon: Truck },
  scope3_aval: { color: 'indigo', label_fr: 'Scope 3 Aval', label_de: 'Scope 3 Downstream', icon: Leaf },
  scope3_3: { color: 'orange', label_fr: 'Scope 3.3', label_de: 'Scope 3.3', icon: Zap },
  scope3: { color: 'purple', label_fr: 'Scope 3', label_de: 'Scope 3', icon: Truck }
};
